<template>
  <section
    :id="section.id"
    :class="[
      'content-section',
      userStatus == null ? '' : 'extended'
    ]"
  >
    <div class="container">
      <div class="small-content">
        <div
          :class="[
            'text-center section-title-margin',
            section.is_visible ? 'fade-in' : 'fade-out',
          ]"
        >
          <div class="hero-stage">
            <div
              ref="heroVisual"
              :class="['hero-stage-visual', { 'hero-stage-visual--alt': isMainHeroAlt, 'is-swapping': mainHeroBlanking }]"
            >
              <img
                ref="heroImage"
                :src="heroMainImages[0]"
                alt="Mr. Canceller"
                :class="['hero-stage-image', { 'is-hidden': isMainHeroAlt }]"
                :style="heroTiltStyle"
              >
              <img
                :src="currentAltImage"
                alt="Mr. Canceller"
                :class="['hero-stage-image', 'hero-stage-image-2', { 'is-hidden': !isMainHeroAlt }]"
                :style="heroTiltStyle"
              >
              <div :class="['hero-stage-gradient', { 'hero-stage-gradient--alt': isMainHeroAlt }]" />
              <Transition name="hero-stage-speech-pop">
                <div
                  v-if="mainHeroSpeaking"
                  :class="['hero-stage-speech', { 'hero-stage-speech--default': !isMainHeroAlt, 'hero-stage-speech--third': mainHeroIndex === 2 }]"
                >
                  {{ currentMainHeroPhrase }}
                  <div class="hero-stage-speech-tail" />
                </div>
              </Transition>
            </div>
            <ContentSectionStableCoinExplanationHeroBubbles
              ref="heroBubbles"
              :paused="mainHeroSpeaking"
            />
            <h2 class="section-title mb-8 hero-stage-title">
              {{ getContent('section_stablecoin_explanation.title_1') }}
            </h2>
            <p class="card-description content-text text-center font-bold section-title-margin hero-stage-subtitle">
              {{ getContent('section_stablecoin_explanation.subtitle_paragraph_1') }}
            </p>
          </div>
          <div class="coin coin--memecoin coin-rotation">
            <div class="coin-tails" />
            <div class="coin-heads" />
          </div>
          <h2
            :id="contentSectionId.memecoin_explanation"
            class="section-title mb-8 memecoin-title"
          >
            {{ getContent('section_stablecoin_explanation.title_2') }}
          </h2>
          <p class="card-description content-text text-center">
            <b>
              {{ getContent('section_stablecoin_explanation.subtitle_paragraph_2_1') }}
            </b>
            <br>
            {{ getContent('section_stablecoin_explanation.subtitle_paragraph_2_2') }}
          </p>
          <div class="stages-wrap">
            <ContentSectionStableCoinExplanationStages />
          </div>
        </div>
      </div>
      <div class="big-content">
        <div class="bottom-block">
          <div
            :class="[
              'bottom-block-column',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
            :style="{ transitionDelay: getFadeTransitionDelay(1) }"
          >
            <h3 class="section-title small text-center mb-8">
              {{ getContent('section_stablecoin_explanation.bottom_block_title_1') }}
            </h3>
            <div class="dashed-block">
              <ul class="dashed-block-content">
                <li class="dashed-block-content-list-item">
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_1_item_1') }}
                  <br>
                </li>
                <li>
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_1_item_2') }}
                </li>
              </ul>
            </div>
          </div>
          <div
            :class="[
              'bottom-block-column',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
            :style="{ transitionDelay: getFadeTransitionDelay(2) }"
          >
            <h3 class="section-title small text-center mb-8">
              {{ getContent('section_stablecoin_explanation.bottom_block_title_2') }}
            </h3>
            <div class="dashed-block">
              <ul class="dashed-block-content">
                <li class="dashed-block-content-list-item">
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_1_row_1') }}
                  <br>
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_1_row_2') }}
                </li>
                <li class="dashed-block-content-list-item">
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_2_row_1') }}
                  <br>
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_2_row_2') }}
                </li>
                <li>
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_3_row_1') }}
                  <br>
                  {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_3_row_2') }}
                  <button
                    class="open-dialog-button"
                    @click="toggleDialog"
                  >
                    {{ getContent('section_stablecoin_explanation.bottom_block_list_2_item_3_row_2_button') }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ClientOnly>
      <AppDialog
        v-model="isDialogVisible"
        open-query-param="is_modal"
        open-query-value="how_to_buy"
        :title="getContent('section_stablecoin_explanation.dialog_title')"
      >
        <LazyHowToBuyUsdcOnBaseDialogContent v-if="isDialogVisible"/>
      </AppDialog>
    </ClientOnly>
  </section>
</template>

<script>
import heroMainImage1 from '@/assets/images/bubble_mainHero.webp'
import heroMainImage2 from '@/assets/images/bubble_mainHero2.png'
import heroMainImage3 from '@/assets/images/bubble_mainHero3.webp'
import heroMainImage4 from '@/assets/images/bubble_mainHero4.webp'

const HERO_TILT_MAX_DEG = 11
const HERO_TILT_RANGE_PX = 600

const MAIN_HERO_SILENT_DURATION = 5000
const MAIN_HERO_SPEAK_DURATION = 3000
const MAIN_HERO_BLANK_OUT = 320
const MAIN_HERO_BLANK_IN = 120

export default {
  name: 'ContentSectionStableCoinExplanation',
  data: () => ({
    heroMainImages: [heroMainImage1, heroMainImage2, heroMainImage3, heroMainImage4],
    mainHeroPhrases: [
      getContent('section_stablecoin_explanation.main_hero_phrase_1'),
      getContent('section_stablecoin_explanation.main_hero_phrase_2'),
      getContent('section_stablecoin_explanation.main_hero_phrase_3'),
      getContent('section_stablecoin_explanation.main_hero_phrase_4'),
    ],
    mainHeroIndex: 0,
    isDialogVisible: false,
    heroTiltX: 0,
    heroTiltY: 0,
    mainHeroSpeaking: false,
    mainHeroBlanking: false,
    mainHeroTimers: [],
    section: {
      id: contentSectionId.stablecoin_explanation,
      is_visible: true,
    },
  }),
  computed: {
    userStatus () {
      const user = useState(appStateConstants.USER)
      return user?.value?.status
    },
    heroTiltStyle () {
      return {
        transform: `perspective(1400px) rotateX(${this.heroTiltX}deg) rotateY(${this.heroTiltY}deg)`,
      }
    },
    isMainHeroAlt () {
      return this.mainHeroIndex !== 0
    },
    currentAltImage () {
      return this.heroMainImages[this.mainHeroIndex]
    },
    currentMainHeroPhrase () {
      return this.mainHeroPhrases[this.mainHeroIndex]
    },
  },
  mounted () {
    window.addEventListener('mousemove', this.handleHeroMouseMove, { passive: true })
    this.runMainHeroCycle()
  },
  beforeUnmount () {
    window.removeEventListener('mousemove', this.handleHeroMouseMove)
    this.mainHeroTimers.forEach(clearTimeout)
  },
  methods: {
    toggleDialog() {
      this.isDialogVisible = !this.isDialogVisible;
    },
    handleHeroMouseMove (event) {
      const visual = this.$refs.heroVisual
      if (!visual) return

      const rect = visual.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2

      const dx = clamp((event.clientX - centerX) / HERO_TILT_RANGE_PX, -1, 1)
      const dy = clamp((event.clientY - centerY) / HERO_TILT_RANGE_PX, -1, 1)

      this.heroTiltY = dx * HERO_TILT_MAX_DEG
      this.heroTiltX = -dy * HERO_TILT_MAX_DEG
    },
    scheduleMainHero (fn, delay) {
      this.mainHeroTimers.push(setTimeout(fn, delay))
    },
    runMainHeroCycle () {
      this.mainHeroSpeaking = false

      this.scheduleMainHero(() => {
        const startSpeaking = () => {
          this.mainHeroSpeaking = true

          this.scheduleMainHero(() => {
            const nextIndex = (this.mainHeroIndex + 1) % this.heroMainImages.length

            this.mainHeroSpeaking = false
            this.mainHeroBlanking = true
            this.scheduleMainHero(() => {
              this.mainHeroIndex = nextIndex
              this.scheduleMainHero(() => {
                this.mainHeroBlanking = false
                this.runMainHeroCycle()
              }, MAIN_HERO_BLANK_IN)
            }, MAIN_HERO_BLANK_OUT)
          }, MAIN_HERO_SPEAK_DURATION)
        }

        const heroBubbles = this.$refs.heroBubbles
        if (heroBubbles) {
          heroBubbles.requestPause().then(startSpeaking)
        } else {
          startSpeaking()
        }
      }, MAIN_HERO_SILENT_DURATION)
    },
  }
}

function clamp (value, min, max) {
  return Math.min(Math.max(value, min), max)
}
</script>

<style lang="scss" scoped>
.content-section {
  margin: 32px 0 64px;
}
.content-section.extended {
  margin: 170px 0 64px;
}

.hero-stage {
  position: relative;
  z-index: 5;
  padding-top: 278px;
}

.hero-stage-visual {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  width: 100%;
  max-width: 800px;
  aspect-ratio: 2 / 1;
  pointer-events: none;
  transform: translateX(-50%);
}

.hero-stage-visual--alt {
  max-width: 400px;
  aspect-ratio: 1 / 1;
}

.hero-stage-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform .2s ease-out, opacity .4s ease-in-out;
  will-change: transform, opacity;

  &.is-hidden {
    opacity: 0;
    pointer-events: none;
  }
}
.hero-stage-visual.is-swapping .hero-stage-image:not(.is-hidden) {
  opacity: 0;
  transition: opacity .3s ease;
}
.hero-stage-image-2 {
  border-radius: 50%;
  top: -6%;
}

.hero-stage-gradient {
  position: absolute;
  left: 21%;
  right: 7%;
  bottom: -1%;
  height: 77%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
}

.hero-stage-gradient--alt {
  left: 6%;
  right: 2%;
  bottom: -1%;
  height: 83%;
}

.hero-stage-speech {
  position: absolute;
  bottom: 32%;
  left: 71%;
  white-space: nowrap;
  padding: 10px 16px;
  border-radius: 20px;
  background-color: $yellow-200;
  color: $black;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  z-index: 4;
  transform: translateY(-50%);
  transform-origin: left center;
}

.hero-stage-speech.hero-stage-speech--default {
  top: 18%;
  bottom: auto;
  left: 66%;
}

.hero-stage-speech.hero-stage-speech--third {
  bottom: 55%;
  left: 55%;
}

.hero-stage-speech-tail {
  position: absolute;
  bottom: -5px;
  left: -3px;
  width: 18px;
  height: 25px;
  background-color: $yellow-200;
  -webkit-mask-image: url('@/assets/images/speach_tile.svg');
  mask-image: url('@/assets/images/speach_tile.svg');
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  transform: rotate(10deg);
  transform-origin: top right;
}

.hero-stage-speech-pop-enter-active {
  transition: opacity .35s ease, transform .35s cubic-bezier(.34, 1.56, .64, 1);
}
.hero-stage-speech-pop-leave-active {
  transition: opacity .25s ease, transform .25s ease;
}
.hero-stage-speech-pop-enter-from,
.hero-stage-speech-pop-leave-to {
  opacity: 0;
  transform: translateY(-50%) scale(.3);
}

.hero-stage-title {
  position: relative;
  z-index: 2;
}

.hero-stage-subtitle {
  position: relative;
  z-index: 2;
}

.stages-wrap {
  padding-top: 82px;
  overflow-x: auto;
  overflow-y: visible;
  height: 220px;
  padding-bottom: 16px;
  margin-bottom: -16px;
}

.memecoin-title {
  scroll-margin: 50px;
}

.bottom-block {
  gap: 32px;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  .bottom-block-column {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    width: calc((100% - 32px) / 2);

    .dashed-block {
      height: 100%;
      padding: 16px;
      display: flex;
      padding-left: 40px;
      border-radius: 16px;
      flex-direction: column;
      justify-content: space-between;
      border: 1px $yellow-100 dashed;

      .dashed-block-content {
        color: $white;
        font-size: 16px;
        line-height: 24px;

        .dashed-block-content-list-item {
          margin-bottom: 24px;
        }

        .open-dialog-button {
          outline: 0;
          border: none;
          cursor: pointer;
          font-size: 16px;
          transition: .2s;
          background: none;
          line-height: 24px;
          color: $yellow-100;
          display: inline-block;
          text-decoration: underline;

          &:hover {
            color: $orange-100;
          }

          &:active,
          &:focus {
            outline: 0;
          }
        }
      }
    }
  }
}

.coin {
  width: 280px;
  height: 280px;
  margin: 32px auto;
  border-radius: 50%;
  position: relative;
  background-size: cover;
  background-position: center;
  -webkit-transform-style: preserve-3d;

  &::before {
    left: 0;
    content: '';
    width: 280px;
    height: 280px;
    position: absolute;
    border-radius: 50%;
    -webkit-transform: translateZ(-19.5px);
    background: repeating-linear-gradient(to bottom, #aaa, #aaa 2px, #888 2px, #888 4px);
  }

  &::after {
    content: '';
    left: 120px;
    width: 20px;
    z-index: -10;
    height: 280px;
    position: absolute;
    -webkit-transform: rotateY(-90deg);
    -webkit-transform-origin: 100% 50%;
    background: repeating-linear-gradient(to bottom, #aaa, #aaa 2px, #888 2px, #888 4px);
  }

  .coin-tails {
    content: '';
    width: 280px;
    height: 280px;
    position: absolute;
    border-radius: 50%;
    -webkit-transform: translateZ(-0.5px);
    background: repeating-linear-gradient(to bottom, #aaa, #aaa 2px, #888 2px, #888 4px);
  }

  .coin-heads {
    width: 280px;
    height: 280px;
    position: absolute;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    -webkit-transform: translateZ(-20px) scale(-1, 1);
  }

  &--memecoin {
    background-size: contain;
    background-position: bottom;
    background-image: url('@/assets/images/moneta21.png'), url('@/assets/images/moneta2_bg.png');
  }

  &--memecoin .coin-heads {
    background-size: 90% 80%, contain;
    background-repeat: no-repeat;
    background-position: 74% 100%, center;
    background-image: url('@/assets/images/moneta22.png'), url('@/assets/images/moneta2_bg.png');
  }
}

@media only screen and (max-width: $sm) {
  .content-section.extended {
    margin: 32px 0 64px;
  }
  .bottom-block {
    flex-direction: column;

    .bottom-block-column {
      width: 100%;

      .dashed-block {
        height: auto;
      }
    }
  }

  .memecoin-title {
    scroll-margin: 30px;
  }
}

@media only screen and (max-width: $xs) {
  .hero-stage {
    padding-top: 150px;
  }
  .hero-stage-gradient:not(.hero-stage-gradient--alt) {
    right: 17%;
    height: 30%;
  }
  .hero-stage-image-2 {
    left: 15%;
    width: 70%;
    height: 70%;
    top: -15%;
  }
  .hero-stage-gradient--alt {
    left: 6%;
    right: 2%;
    bottom: 43%;
    height: 55%;
  }
  .hero-stage-speech {
    bottom: 55%;
    left: 70%;
    padding: 8px 12px;
    white-space: break-spaces;
  }
  .hero-stage-speech.hero-stage-speech--third {
    bottom: 70%;
    left: 55%;
  }
}
</style>
